// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".formatted-text{font-size:14px !important;display:inline}.formatted-text.formatted-text-title{font-size:24px !important}.formatted-text.formatted-text-large{font-size:16px !important}.formatted-text.formatted-text-small{font-size:10px !important}.formatted-text.formatted-text-bold{font-weight:bold !important}.formatted-text-paragraph{margin-bottom:14px;white-space:pre-line}", ""]);
// Exports
module.exports = exports;
